import React from 'react';
import { Box, Flex, Text } from '@zillow/constellation-10';
import { useTransactionInformation } from 'src/store/useTransactionInformation';
import { SystemStyleObject } from '@/styled-system/types';
import { NotYourState } from '../NotYourState';
import { StateAbbreviationToLongName } from 'src/enums/states';

interface IStateInfoBlockProps {
  css?: SystemStyleObject;
  fixedWidth?: boolean;
}

export const StateInfoBlock: React.FC<IStateInfoBlockProps> = ({ css, fixedWidth = true }) => {
  const {
    info: { state },
  } = useTransactionInformation();

  return (
    <>
      {state && (
        <>
          {fixedWidth && <Box css={{ flexGrow: 1, ...css }}></Box>}
          <Flex
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: fixedWidth ? 'flex-end' : 'center',
              width: fixedWidth ? '50%' : 'auto',
              ...css,
            }}
          >
            <Text css={{ textAlign: 'right', textStyle: 'body-sm-bold' }}>{StateAbbreviationToLongName[state]}</Text>
            <NotYourState />
          </Flex>
        </>
      )}
    </>
  );
};
